import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authApi, schoolApi } from '../../api/client';
import { FaEnvelope, FaSchool, FaCheckCircle } from 'react-icons/fa';
import toast from 'react-hot-toast';
import Spinner from '../../components/common/Spinner';

export default function ForgotPassword() {
  const { slug }    = useParams();
  const navigate    = useNavigate();
  const [school,    setSchool]  = useState(null);
  const [email,     setEmail]   = useState('');
  const [loading,   setLoading] = useState(false);
  const [fetching,  setFetching] = useState(!!slug);
  const [sent,      setSent]    = useState(false);
  const isSuperAdmin = !slug;

  useEffect(() => {
    if (!slug) { setFetching(false); return; }
    schoolApi.getInfo(slug)
      .then(r => setSchool(r.data.data))
      .catch(() => navigate('/'))
      .finally(() => setFetching(false));
  }, [slug, navigate]);

  const primary = school?.primary_color || '#0d6efd';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { email };
      if (!isSuperAdmin && slug) payload.school_slug = slug;
      await authApi.forgotPassword(payload);
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong');
    } finally { setLoading(false); }
  };

  if (fetching) return <div className="login-page"><Spinner /></div>;

  return (
    <div className="login-page" style={school ? { background: `linear-gradient(135deg, #1a1a2e, ${primary}55)` } : {}}>
      <div className="login-card">
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          {school?.logo
            ? <img src={school.logo} alt="logo" style={{ width: 64, height: 64, borderRadius: 14, objectFit: 'cover', marginBottom: 12 }} />
            : <div style={{ width: 64, height: 64, borderRadius: 14, background: primary, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                <FaSchool size={28} color="#fff" />
              </div>
          }
          <h2 style={{ fontWeight: 700, fontSize: '1.3rem', color: '#111827' }}>
            {sent ? 'Check Your Email' : 'Forgot Password'}
          </h2>
          <p style={{ color: '#6b7280', fontSize: '0.85rem', marginTop: 4 }}>
            {sent ? `We sent a reset link to ${email}` : (school?.name || 'School SMS')}
          </p>
        </div>

        {sent ? (
          /* Success state */
          <div>
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <FaCheckCircle size={52} color="#10b981" style={{ marginBottom: 16 }} />
              <p style={{ color: '#374151', lineHeight: 1.7, fontSize: '0.92rem' }}>
                If an account with <strong>{email}</strong> exists, you'll receive a password reset link within a few minutes.
              </p>
              <p style={{ color: '#6b7280', fontSize: '0.82rem', marginTop: 8 }}>
                Check your spam folder if you don't see it.
              </p>
            </div>
            <button
              onClick={() => slug ? navigate(`/school/${slug}/login`) : navigate('/super-admin/login')}
              className="sms-btn sms-btn-primary"
              style={{ width: '100%', justifyContent: 'center', background: primary }}>
              Back to Login
            </button>
          </div>
        ) : (
          /* Form */
          <form onSubmit={handleSubmit}>
            <p style={{ color: '#6b7280', fontSize: '0.88rem', marginBottom: 20, lineHeight: 1.6 }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <div style={{ marginBottom: 20 }}>
              <label className="sms-label">Email Address</label>
              <div style={{ position: 'relative' }}>
                <FaEnvelope style={{ position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
                <input
                  className="sms-input"
                  style={{ paddingLeft: 38 }}
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="sms-btn sms-btn-primary"
              style={{ width: '100%', justifyContent: 'center', background: primary, marginBottom: 16 }}>
              {loading ? <Spinner size={18} color="#fff" /> : 'Send Reset Link'}
            </button>
            <div style={{ textAlign: 'center' }}>
              <button
                type="button"
                onClick={() => slug ? navigate(`/school/${slug}/login`) : navigate('/super-admin/login')}
                style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: '0.83rem' }}>
                ← Back to Login
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
